import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { formControlActions } from 'store/formControlSlice/formControlSlice';
import * as formSelectors from 'store/formControlSlice/formControlSelectors';

export const AGENT_AUDIO_TIME_FIELD = 'agentAudioTime';

const useAgentAudioTimeTracker = ({ transactionId }) => {
    const dispatch = useDispatch();
    const store = useStore();

    return useCallback(() => {
        if (!transactionId) return;

        const state = store.getState();
        const formEntry = formSelectors.selectFormById(transactionId)(state);
        if (!formEntry) return;

        const formState = formSelectors.createFormStateByTransactionIdSelector(transactionId)(state);
        const transactionData = formSelectors.selectTransactionDataByTransactionId(transactionId)(state);
        const isAlreadySet = Boolean(formState?.values?.[AGENT_AUDIO_TIME_FIELD] || transactionData?.[AGENT_AUDIO_TIME_FIELD]);
        if (isAlreadySet) return;

        dispatch(
            formControlActions.setFieldValue({
                formId: transactionId,
                fieldName: AGENT_AUDIO_TIME_FIELD,
                value: new Date().toISOString(),
            })
        );
    }, [transactionId, dispatch, store]);
};

export default useAgentAudioTimeTracker;
